<template>
<div v-if="data">
  <div class="container py-4">

    <!-- HEADER -->
    <div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4 gap-2">
      <h2 class="fw-bold text-primary mb-2 mb-md-0">
        <i class="bi bi-hospital"></i> Détails de l’hospitalisation
      </h2>

      <div class="d-flex flex-wrap gap-2">
       <div v-if="$store.getters.hasPermission('HOSP_IMPRESSION')" class="dropdown">
  <button class="btn btn-outline-primary dropdown-toggle" data-bs-toggle="dropdown" v-dropdown-fixed>
    <i class="bi bi-printer"></i> Imprimer
  </button>

  <ul class="dropdown-menu">
    <li>
      <a class="dropdown-item" @click="imprimerHospitalisationA4(data)">
        Format A4
      </a>
    </li>
    <li>
      <a class="dropdown-item" @click="imprimerHospitalisationTicketEpson(data)">
        Ticket 80 mm
      </a>
    </li>
     <li>
      <a class="dropdown-item" @click="imprimerHospitalisationTicket58(data)">
        Ticket 58mm
      </a>
    </li>
  </ul>
</div>

        <button
          v-if="(data && data.resteAPayer > 0) && data.statut !== 'Clôturée' && $store.getters.hasPermission('HOSP_PAIEMENT')"
          class="btn btn-warning"
          @click="ouvrirPaiement(data)"
        >
          <i class="bi bi-cash-stack"></i> Paiement
        </button>

        <button
          v-if="data && data.statut !== 'Clôturée'  && $store.getters.hasPermission('HOSP_CLOTURE')"
          class="btn btn-success"
          @click="showModal = true"
        >
          <i class="bi bi-check2-circle"></i> Clôturer
        </button>

        <button
          v-if="data && data.statut === 'Clôturée' && $store.getters.hasPermission('HOSP_CLOTURE_ANNULE')"
          class="btn btn-danger"
          @click="annulerCloture"
        >
          <i class="bi bi-arrow-counterclockwise"></i> Annuler la clôture
        </button>

        <button class="btn btn-secondary" @click="$router.back()">
          <i class="bi bi-arrow-left"></i> Retour
        </button>
      </div>
    </div>

    <!-- CONTENU -->
    <div class="card shadow-sm p-4 content-print">

      <!-- MODAL CLOTURE -->
      <div v-if="showModal" class="modal-backdrop-custom">
        <div class="modal-custom">
          <h5 class="fw-bold">Clôturer l’hospitalisation</h5>

          <label class="mt-3">Date de sortie réelle :</label>
          <input type="date" v-model="dateSortieReelle" class="form-control" />

          <div class="mt-3 d-flex justify-content-end gap-2 flex-wrap">
            <button class="btn btn-secondary" @click="showModal = false">Annuler</button>
            <button class="btn btn-success" @click="cloturerHospitalisation">Valider</button>
          </div>
        </div>
      </div>

      <!-- PATIENT -->
      <h4 class="section-title"><i class="bi bi-person"></i> Informations Patient</h4>
      <div class="row mb-3">
        <div class="col-12 col-sm-6 col-md-4"><strong>Nom :</strong> {{ data.patient?.nom }} {{ data.patient?.prenom }}</div>
        <div class="col-12 col-sm-6 col-md-4"><strong>Dossier :</strong> {{ data.patient?.numeroDossier }}</div>
        <div class="col-12 col-sm-6 col-md-4"><strong>Téléphone :</strong> {{ data.patient?.telephone }}</div>
      </div>

      <hr />

      <!-- HOSPITALISATION -->
      <h4 class="section-title"><i class="bi bi-file-medical"></i> Hospitalisation</h4>
      <div class="row mb-3">
        
        <div class="col-12 col-sm-6 col-md-4"><strong>Date entrée :</strong> {{ formatDate(data.dateEntree) }}</div>
        <div class="col-12 col-sm-6 col-md-4"><strong>Sortie prévue :</strong> {{ formatDate(data.dateSortiePrevue) }}</div>
        <div class="col-12 col-sm-6 col-md-4">
          <strong>Sortie réelle :</strong>
          <span class="text-danger" v-if="!data.dateSortieReelle">En cours</span>
          <span v-else>{{ formatDate(data.dateSortieReelle) }}</span>
        </div>
        <div class="col-12 col-sm-6 col-md-4"><strong>Statut :</strong> {{ data.statut }}</div>
        <div class="col-12 col-sm-6 col-md-4"><strong>Num Hospitalisation :</strong> {{ data.numHospitalisation }}</div>
      </div>

      <hr />

      <!-- CHAMBRE -->
      <h4 class="section-title"><i class="bi bi-door-open"></i> Chambre & Lit</h4>
      <div class="row mb-3">
        <div class="col-12 col-sm-6 col-md-4"><strong>Chambre :</strong> {{ data.chambre?.numero || '—' }}</div>
        <div class="col-12 col-sm-6 col-md-4"><strong>Type :</strong> {{ data.chambre?.type?.nom || '—' }} — {{ data.chambre?.type?.tarifParJour || 0 }} F/jour</div>
        <div class="col-12 col-sm-6 col-md-4"><strong>Lit :</strong> {{ data.lit?.numero || '—' }}</div>
      </div>

      <hr />

      <!-- PAIEMENTS -->
      <h4 class="section-title"><i class="bi bi-cash-stack"></i> Paiements</h4>
      <div class="row g-2">

  <div class="col-12 col-sm-6 col-md-3">
    <strong>Montant calculé :</strong>
    {{ formatPrice(data.montantCalcule?.montant || 0) }} F
  </div>

  <div class="col-12 col-sm-6 col-md-3 text-primary">
    <strong>Part patient :</strong>
    {{ formatPrice(data.totalPartPatient || 0) }} F
  </div>

  <div class="col-12 col-sm-6 col-md-3 text-success">
    <strong>Part assurance :</strong>
    {{ formatPrice(data.totalPartAssurance || 0) }} F
  </div>

  <div class="col-12 col-sm-6 col-md-3">
    <strong>Total payé :</strong>
    {{ formatPrice(data.totalPaye || 0) }} F
  </div>

  <div class="col-12 col-sm-6 col-md-3 text-danger">
    <strong>Reste à payer :</strong>
    {{ formatPrice(data.resteAPayer || 0) }} F
  </div>

  <div
    class="col-12 col-sm-6 col-md-3 text-success"
    v-if="data.remboursement > 0"
  >
    <strong>Remboursement :</strong>
    {{ formatPrice(data.remboursement) }} F
  </div>

</div>

      <!-- HISTORIQUE DES TRANSACTIONS -->
      <div class="card mt-4">
        <div class="card-header fw-bold bg-light">Historique des paiements</div>

        <div class="card-body p-0 table-responsive">
          <table class="table table-bordered mb-0">
            <thead class="table-primary">
              <tr>
                <th>Date</th>
                <th>Montant de base</th>
                <th>Montant Payé</th>
                <th>Assurance</th>
                <th>Taux</th>
                <th>Part Assurance</th>
                <th>Paiement Patient</th>
                
                <th>Type</th>
                <th>Enregistrer par</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!data.paiements || data.paiements.length === 0">
                <td colspan="10" class="text-center text-muted">Aucun paiement enregistré</td>
              </tr>
              <tr v-for="(p, index) in data.paiements" :key="p.id || index">
  <td>{{ formatDateTime(p.datePaiement) }}</td>

  <td>
    {{ formatPrice(p.montantBase || 0) }} F
  </td>

  <td class="fw-bold">
    {{ formatPrice(p.montant || 0) }} F
  </td>

  <td>
  {{ p.contratAssurance?.assurance?.nom || 'Aucune' }}
</td>
<td>
  {{
    p.contratAssurance?.tauxCouverture != null
      ? p.contratAssurance.tauxCouverture + '%'
      : '—'
  }}
</td>

<td class="text-success">
  {{ formatPrice(p.partAssurance || 0) }} F
</td>

<td class="text-primary">
  {{ formatPrice(p.partPatient || 0) }} F
</td>



  <td>
    <span class="badge bg-info">
      {{ p.type }}
    </span>
  </td>

  <td>
    {{ p.createdBy?.nom || p.userNom || '' }}
    {{ p.createdBy?.prenom || p.userPrenom || '' }}
  </td>

  <td>
    <div class="btn-group btn-group-sm">

      <button
        class="btn btn-outline-success"
        @click="imprimerPaiementHospitalisationA4(p, data)"
      >
        A4
      </button>

      <button
        class="btn btn-outline-dark"
        @click="imprimerPaiementHospitalisationTicketEpson(p, data)"
      >
        80mm
      </button>

      <button
        class="btn btn-outline-secondary"
        @click="imprimerPaiementHospitalisationTicket58(p, data)"
      >
        58mm
      </button>

    </div>
  </td>
</tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>

    <!-- MODAL PAIEMENT -->
   <PaiementHospitalisationModal
  :visible="modalPaiementVisible"
  :hospitalisation="hospitalisationPourPaiement"
  :patientId="data?.patient?.id"
  @fermer="fermerPaiement"
  @paiementEffectue="onPaiementEffectue"
/>
  </div>
</div>

<div v-else-if="loadError" class="text-center my-5">
  <p class="text-danger fw-bold">Impossible de charger cette hospitalisation.</p>
  <button class="btn btn-outline-primary" @click="loadDetails">Réessayer</button>
</div>

<div v-else class="text-center my-5">
  <div class="spinner-border text-primary" style="width:50px;height:50px"></div>
  <p class="mt-2">Chargement en cours...</p>
</div>
</template>

<script>
import api from "@/api";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);
import PaiementHospitalisationModal from "@/components/PaiementHospitalisationModal.vue";

export default {
  components: { PaiementHospitalisationModal },

  data() {
    return {
      data: null,
      loading: true,
      loadError: false,
      showModal: false,
      dateSortieReelle: dayjs().format('YYYY-MM-DD'),
      hospitalisationPourPaiement: null,
      modalPaiementVisible: false,
      systeme: null,
      isLoadingSysteme: false,
    };
  },

  created() {
     this.loadSysteme();
    this.loadDetails();
    
  },
  computed: {
    montantReelCalcule() {

    if (!this.data) return { montant: 0, jours: 0 }

    const tarif = this.data.chambre?.type?.tarifParJour || 0

    const dateEntree = dayjs(this.data.dateEntree)

    // on utilise la date de sortie saisie dans le modal
    const dateSortie = dayjs(this.dateSortieReelle)

    const jours = dateSortie.diff(dateEntree, "day") + 1

    const montant = tarif * jours
  
    return {
      montant,
      jours
    }
  },

  // NOTE : cette valeur teste si l'hospitalisation POSSEDE DEJA une date de
  // sortie réelle enregistrée côté serveur (donc déjà clôturée), ce qui n'est
  // en pratique presque jamais vrai avant de cliquer sur "Valider". Ce computed
  // n'est utilisé nulle part dans le template actuel — je le laisse tel quel
  // (bug de référence corrigé : montantCloture -> montantReelCalcule) mais je
  // ne l'ai pas branché sur le bouton "Valider" du modal, faute de connaître
  // le comportement métier voulu. Dites-moi si vous voulez qu'il désactive
  // le bouton tant que le paiement est insuffisant.
  cloturePossible() {

    if (!this.data?.dateSortieReelle) {
      return false
    }

    return this.data.totalPaye >= this.montantReelCalcule.montant
  }

},

  methods: {
 formatDate(date) {
  if (!date) return "—";

  return dayjs(String(date).substring(0, 10)).format("DD-MM-YYYY");
},
    formatDateTime(date) {
  if (!date) return '—';

  return dayjs(date)
    .tz('Africa/Bamako')
    .format('DD-MM-YYYY HH:mm');
},
    formatPrice(value) { return new Intl.NumberFormat().format(value); },

    async loadDetails() {
      this.loading = true;
      this.loadError = false;
      try {
        const res = await api.getItem("hospitalisations", this.$route.params.id);
        this.data = res.data;
      } catch (e) {
        console.error("Erreur chargement hospitalisation :", e);
        this.data = null;
        this.loadError = true;
      }
      finally { this.loading = false; }
    },

    ouvrirPaiement(hosp) {
      this.hospitalisationPourPaiement = hosp;
      this.modalPaiementVisible = true;
    },
    fermerPaiement() {
      this.modalPaiementVisible = false;
      this.hospitalisationPourPaiement = null;
    },
  async effectuerPaiement(payload) {
  try {
    const res = await api.createItem(
      'paiement_hospitalisations',
      payload
    );

    const nouveauPaiement = res.data;

    if (nouveauPaiement) {

      if (!Array.isArray(this.data.paiements)) {
        this.data.paiements = [];
      }

      this.data.paiements.unshift(nouveauPaiement);

      // Le paiement réellement encaissé auprès du patient
      const partPatient = Number(
        nouveauPaiement.partPatient || 0
      );

      this.data.totalPaye =
        Number(this.data.totalPaye || 0) + partPatient;

      this.data.resteAPayer = Math.max(
        Number(this.data.montantCalcule?.montant || 0)
        - Number(this.data.totalPaye || 0),
        0
      );
    }

    this.fermerPaiement();

    await this.loadDetails();

  } catch (e) {
    console.error(e);

    const message =
      e?.response?.data?.detail ||
      e?.response?.data?.message ||
      "Erreur lors du paiement.";

    alert(message);
  }
},
async onPaiementEffectue() {
  this.fermerPaiement();
  await this.loadDetails();
},
 
    montantDeCalcul(p) {
      if (!p.assurance) return 0;
      return (p.montant) / (1 - (p.assurance.tauxCouverture /100));
    },
    partAssurance(p) {
      if (!p.assurance) return 0;
      const taux = p.assurance.tauxCouverture / 100;
      const montantTotal = p.montant / (1 - taux);
      return montantTotal - p.montant;
    },
    partPatient(p) { return p.montant; },

    async annulerCloture() {
      if (!confirm("Annuler la clôture ?")) return;
      try {
        await api.updateItem("hospitalisations", this.$route.params.id, {
          statut: "En cours",
          dateSortieReelle: null
        });
        await api.updateItem("lits", this.data.lit.id, { etat: "Occupé" });
        await this.loadDetails();
        alert("Clôture annulée.");
      } catch (e) {
        console.error("Erreur annulation clôture :", e);
        alert("Erreur.");
      }
    },
    async loadSysteme() {
  this.isLoadingSysteme = true;
  try {
    const res = await api.getItems('configurations');

    //  prendre le premier élément du tableau
    this.systeme = res.data?.data?.[0] || null;

  } catch (e) {
    console.error("Erreur chargement système", e);
  } finally {
    this.isLoadingSysteme = false;
  }
}
,

   async cloturerHospitalisation() {
  if (this.data.totalPaye < this.montantReelCalcule?.montant) {
    alert("Paiement insuffisant !");
    return;
  }
  try {
    await api.custom(
      `hospitalisations/${this.$route.params.id}/cloturer`,
      "PATCH",
       {
         dateSortieReelle: this.dateSortieReelle
       }
    );

    this.showModal = false;
    await this.loadDetails(); 

  } catch (e) {
    console.error("Erreur clôture hospitalisation :", e);
    alert("Erreur lors de la clôture.");
  }
}
,

async imprimerHospitalisationA4(hospitalisation) {

  if (!hospitalisation) return;

  // IMPORTANT : on ouvre la fenêtre AVANT tout `await`. Si on l'ouvre après
  // un appel réseau, le navigateur perd le contexte "clic utilisateur" et
  // bloque silencieusement le popup (bug fréquent, difficile à remarquer
  // car il n'y a aucune erreur visible - la fenêtre ne s'ouvre juste pas).
  const printWindow = window.open("", "_blank");

  if (!printWindow) {
    console.error("Impossible d'ouvrir la fenêtre d'impression (bloquée par le navigateur ?).");
    alert("Le navigateur a bloqué l'ouverture de la fenêtre d'impression. Autorisez les pop-ups pour ce site.");
    return;
  }

  const config = this.systeme || {};
  const user = this.$store.getters.user || {};

  const patient = hospitalisation.patient || {};
  const chambre = hospitalisation.chambre || {};
  const lit = hospitalisation.lit || {};
  const typeChambre = chambre.type || {};

  /**
   * ============================================================
   * RECUPERATION DES PAIEMENTS
   * ============================================================
   */
  let paiements = [];

  try {
    const res = await api.getItems(
      "paiement_hospitalisations",
      { hospitalisation: hospitalisation.id }
    );

    paiements = res.data?.data || [];

  } catch (error) {
    console.error("Erreur récupération paiements", error);
  }

  // Fallback : paiements déjà présents dans l'hospitalisation
  if (!paiements.length && Array.isArray(hospitalisation.paiements)) {
    paiements = hospitalisation.paiements;
  }

  /**
   * ============================================================
   * CONTRATS D'ASSURANCE UTILISES
   * ============================================================
   *
   * Le nom de l'assurance est dans :
   *
   * paiement.contratAssurance.assurance.nom
   *
   * Le numéro assuré :
   *
   * paiement.contratAssurance.numeroAssure
   *
   * Le taux :
   *
   * paiement.contratAssurance.tauxCouverture
   */
  const paiementsAvecContrat = paiements.filter(
    p => p.contratAssurance
  );

  /**
   * ============================================================
   * CALCUL DES PARTS
   * ============================================================
   */
  let totalPatient = 0;
  let totalAssurance = 0;

  paiements.forEach(p => {

    totalPatient += Number(p.partPatient || 0);

    totalAssurance += Number(p.partAssurance || 0);

  });

  /**
   * ============================================================
   * DATES
   * ============================================================
   */
  const dateEntree = this.formatDate(
    hospitalisation.dateEntree
  );

  const dateSortiePrevue = this.formatDate(
    hospitalisation.dateSortiePrevue
  );

  const dateSortieReelle = hospitalisation.dateSortieReelle
    ? this.formatDate(hospitalisation.dateSortieReelle)
    : "En cours";

  /**
   * ============================================================
   * REFERENCE
   * ============================================================
   */
  const reference =
    hospitalisation.numHospitalisation ||
    `HOSP-${hospitalisation.id}-${new Date().getFullYear()}`;

  /**
   * ============================================================
   * TARIF CHAMBRE PAR JOUR
   * ============================================================
   */
  const tarifParJour = Number(
    typeChambre.tarifParJour || 0
  );

  /**
   * ============================================================
   * NOMBRE DE JOURS
   * ============================================================
   *
   * Priorité à montantCalcule.jours
   * sinon montantReelCalcule.jours
   */
  const nombreJours = Number(
    hospitalisation.montantCalcule?.jours ||
    hospitalisation.montantReelCalcule?.jours ||
    0
  );

  /**
   * ============================================================
   * MONTANTS
   * ============================================================
   */
  const montantCalcule = Number(
    hospitalisation.montantCalcule?.montant ||
    hospitalisation.montantReelCalcule?.montant ||
    hospitalisation.montantFacture ||
    0
  );

  const totalPaye = Number(
    hospitalisation.totalPaye || 0
  );

  const resteAPayer = Number(
    hospitalisation.resteAPayer || 0
  );

  const remboursement = Number(
    hospitalisation.remboursement || 0
  );

  /**
   * ============================================================
   * SERVEUR / LOGO
   * ============================================================
   */
  const baseURL =
    process.env.VUE_APP_API_BASE_URL ||
    "http://127.0.0.1:8000";

  const logoUrl = config.logo
    ? (
        config.logo.startsWith("http")
          ? config.logo
          : `${baseURL}${config.logo}`
      )
    : "";

  /**
   * ============================================================
   * HTML
   * ============================================================
   */
  const html = `
<!DOCTYPE html>
<html>
<head>

<title>Hospitalisation ${reference}</title>

<style>

@page {
  size: A4;
  margin: 1.5cm;
}

body {
  font-family: "Times New Roman", serif;
  font-size: 13px;
  color: #000;
  margin: 0;
  padding: 0;
}

header {
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #0056b3;
  padding-bottom: 10px;
}

header img {
  width: 80px;
  height: 80px;
  object-fit: contain;
}

.clinic-info h2 {
  color: #0056b3;
  margin: 0;
}

.clinic-info p {
  margin: 3px 0;
}

h3 {
  text-align: center;
  color: #0056b3;
  text-decoration: underline;
  margin: 20px 0;
}

.section {
  margin-top: 20px;
}

.section-title {
  font-weight: bold;
  font-size: 15px;
  color: #0056b3;
  border-bottom: 1px solid #0056b3;
  padding-bottom: 5px;
  margin-bottom: 10px;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

td,
th {
  border: 1px solid #0056b3;
  padding: 8px;
}

th {
  background: #e8f1ff;
}

.text-right {
  text-align: right;
}

.text-center {
  text-align: center;
}

.assurance {
  background: #eef7ff;
}

.total-row {
  font-weight: bold;
  font-size: 14px;
}

.signature {
  margin-top: 50px;
  text-align: right;
}

footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid #0056b3;
  font-size: 11px;
  display: flex;
  justify-content: space-between;
  padding-top: 5px;
}

</style>

</head>

<body>

<!-- ========================================================= -->
<!-- EN-TETE -->
<!-- ========================================================= -->

<header>

  <div style="display:flex;gap:10px;">

    ${
      logoUrl
        ? `<img src="${logoUrl}" alt="Logo">`
        : ""
    }

    <div class="clinic-info">

      <h2>
        ${config.nom || "CLINIQUE MÉDICALE"}
      </h2>

      <p>
        ${config.adresse || ""}
      </p>

      <p>
        Tél : ${config.telephone || ""}
      </p>

      ${
        config.email
          ? `<p>Email : ${config.email}</p>`
          : ""
      }

    </div>

  </div>

  <div>

    <p>
      <strong>Référence :</strong>
      ${reference}
    </p>

    <p>
      <strong>Date entrée :</strong>
      ${dateEntree}
    </p>

  </div>

</header>


<!-- ========================================================= -->
<!-- TITRE -->
<!-- ========================================================= -->

<h3>
  FICHE D'HOSPITALISATION
</h3>


<!-- ========================================================= -->
<!-- INFORMATIONS PATIENT -->
<!-- ========================================================= -->

<div class="section">

  <div class="section-title">
    Informations patient
  </div>

  <table>

    <tr>

      <td>
        <strong>Nom :</strong>
        ${patient.nom || ""}
        ${patient.prenom || ""}
      </td>

      <td>
        <strong>Dossier :</strong>
        ${patient.numeroDossier || "—"}
      </td>

    </tr>

    <tr>

      <td>
        <strong>Téléphone :</strong>
        ${patient.telephone || "—"}
      </td>

      <td>
        <strong>Genre :</strong>
        ${patient.genre || "—"}
      </td>

    </tr>

  </table>

</div>


<!-- ========================================================= -->
<!-- INFORMATIONS HOSPITALISATION -->
<!-- ========================================================= -->

<div class="section">

  <div class="section-title">
    Hospitalisation
  </div>

  <table>

    <tr>

      <td>
        <strong>Date entrée</strong>
      </td>

      <td>
        ${dateEntree}
      </td>

      <td>
        <strong>Sortie prévue</strong>
      </td>

      <td>
        ${dateSortiePrevue}
      </td>

    </tr>

    <tr>

      <td>
        <strong>Sortie réelle</strong>
      </td>

      <td>
        ${dateSortieReelle}
      </td>

      <td>
        <strong>Statut</strong>
      </td>

      <td>
        ${hospitalisation.statut || "—"}
      </td>

    </tr>

    <tr>

      <td>
        <strong>Type hospitalisation</strong>
      </td>

      <td colspan="3">
        ${hospitalisation.typeHospitalisation?.libelle || "—"}
      </td>

    </tr>

  </table>

</div>


<!-- ========================================================= -->
<!-- CHAMBRE / LIT / TARIF -->
<!-- ========================================================= -->

<div class="section">

  <div class="section-title">
    Chambre, Lit & Tarification
  </div>

  <table>

    <tr>

      <td>
        <strong>Chambre</strong>
      </td>

      <td>
        ${chambre.numero || "—"}
      </td>

      <td>
        <strong>Lit</strong>
      </td>

      <td>
        ${lit.numero || "—"}
      </td>

    </tr>

    <tr>

      <td>
        <strong>Type chambre</strong>
      </td>

      <td>
        ${typeChambre.nom || "—"}
      </td>

      <td>
        <strong>Tarif / jour</strong>
      </td>

      <td class="text-right">
        ${tarifParJour.toLocaleString()} FCFA
      </td>

    </tr>

    <tr>

      <td>
        <strong>Nombre de jours</strong>
      </td>

      <td>
        ${nombreJours} jour${nombreJours > 1 ? "s" : ""}
      </td>

      <td>
        <strong>Total calculé</strong>
      </td>

      <td class="text-right">
        ${montantCalcule.toLocaleString()} FCFA
      </td>

    </tr>

  </table>

</div>


<!-- ========================================================= -->
<!-- ASSURANCE -->
<!-- ========================================================= -->

<div class="section">

  <div class="section-title">
    Contrat(s) d'assurance utilisé(s)
  </div>

  <table>

    <tr>

      <th>
        Assurance
      </th>

      <th>
        N° assuré
      </th>

      <th>
        Taux couverture
      </th>

      <th>
        Part Assurance
      </th>

    </tr>

    ${
      paiementsAvecContrat.length

      ? paiementsAvecContrat.map(p => {

          const contrat = p.contratAssurance || {};

          const assurance =
            contrat.assurance || null;

          const taux =
            contrat.tauxCouverture != null
              ? Number(contrat.tauxCouverture)
              : 0;

          const partAssurance =
            Number(p.partAssurance || 0);

          return `

          <tr>

            <td class="assurance">
              ${assurance?.nom || "—"}
            </td>

            <td>
              ${contrat.numeroAssure || "—"}
            </td>

            <td class="text-right">
              ${taux} %
            </td>

            <td class="text-right">
              ${partAssurance.toLocaleString()} FCFA
            </td>

          </tr>

          `;

        }).join("")

      : `

        <tr>

          <td
            colspan="4"
            class="text-center"
          >
            Aucun contrat d'assurance
          </td>

        </tr>

        `
    }

  </table>

</div>


<!-- ========================================================= -->
<!-- SITUATION FINANCIERE -->
<!-- ========================================================= -->

<div class="section">

  <div class="section-title">
    Situation financière
  </div>

  <table>

    <tr>

      <th>
        Montant
      </th>

      <th>
        Part Assurance
      </th>

      <th>
        Part Patient
      </th>

      <th>
        Total payé
      </th>

      <th>
        Reste
      </th>

    </tr>

    <tr class="total-row">

      <td class="text-right">
        ${montantCalcule.toLocaleString()} FCFA
      </td>

      <td class="text-right">
        ${totalAssurance.toLocaleString()} FCFA
      </td>

      <td class="text-right">
        ${totalPatient.toLocaleString()} FCFA
      </td>

      <td class="text-right">
        ${totalPaye.toLocaleString()} FCFA
      </td>

      <td class="text-right">
        ${resteAPayer.toLocaleString()} FCFA
      </td>

    </tr>

  </table>

  ${
    remboursement > 0

      ? `

      <p>
        <strong>Remboursement :</strong>
        ${remboursement.toLocaleString()} FCFA
      </p>

      `

      : ""
  }

</div>


<!-- ========================================================= -->
<!-- HISTORIQUE DES PAIEMENTS -->
<!-- ========================================================= -->

<div class="section">

  <div class="section-title">
    Historique des paiements
  </div>

  <table>

    <tr>

      <th>
        Date
      </th>

      <th>
        Mode
      </th>

      <th>
        Assurance
      </th>

      <th>
        N° assuré
      </th>

      <th>
        Taux
      </th>

      <th>
        Base
      </th>

      <th>
        Montant
      </th>

      <th>
        Patient
      </th>

      <th>
        Assurance
      </th>

    </tr>

    ${
      paiements.length > 0

      ? paiements.map(p => {

          const contrat =
            p.contratAssurance || null;

          const assurance =
            contrat?.assurance || null;

          const taux =
            contrat?.tauxCouverture != null
              ? Number(contrat.tauxCouverture)
              : 0;

          const montantBase =
            Number(p.montantBase || 0);

          const montant =
            Number(p.montant || 0);

          const partPatient =
            Number(p.partPatient || 0);

          const partAssurance =
            Number(p.partAssurance || 0);

          return `

          <tr>

            <td>
              ${this.formatDateTime(p.datePaiement)}
            </td>

            <td>
              ${p.modePaiement?.nom || "—"}
            </td>

            <td>
              ${assurance?.nom || "Aucune"}
            </td>

            <td>
              ${contrat?.numeroAssure || "—"}
            </td>

            <td class="text-right">
              ${
                contrat
                  ? `${taux} %`
                  : "—"
              }
            </td>

            <td class="text-right">
              ${montantBase.toLocaleString()} FCFA
            </td>

            <td class="text-right">
              ${montant.toLocaleString()} FCFA
            </td>

            <td class="text-right">
              ${partPatient.toLocaleString()} FCFA
            </td>

            <td class="text-right">
              ${partAssurance.toLocaleString()} FCFA
            </td>

          </tr>

          `;

        }).join("")

      : `

        <tr>

          <td
            colspan="9"
            class="text-center"
          >
            Aucun paiement
          </td>

        </tr>

        `
    }

  </table>

</div>


<!-- ========================================================= -->
<!-- SIGNATURE -->
<!-- ========================================================= -->

<div class="signature">

  <p>
    <strong>L'Agent</strong>
  </p>

  <p>
    ${user.nom || ""}
    ${user.prenom || ""}
  </p>

  <br>

  <p>
    Signature & Cachet
  </p>

</div>


<!-- ========================================================= -->
<!-- FOOTER -->
<!-- ========================================================= -->

<footer>

  <span>
    ${config.nom || ""}
    ${config.adresse || ""}
  </span>

  <span>
    © ${new Date().getFullYear()}
  </span>

</footer>


</body>
</html>
`;

  /**
   * ============================================================
   * IMPRESSION
   * ============================================================
   */

  printWindow.document.open();

  printWindow.document.write(html);

  printWindow.document.close();

  printWindow.onload = () => {

    printWindow.focus();

    printWindow.print();

    printWindow.close();

  };
},

async imprimerHospitalisationTicketEpson(hospitalisation) {

  if (!hospitalisation) return;

  // Ouverture synchrone AVANT tout `await` (voir commentaire dans imprimerHospitalisationA4)
  const printWindow = window.open("", "_blank");

  if (!printWindow) {
    console.error("Impossible d'ouvrir la fenêtre d'impression (bloquée par le navigateur ?).");
    alert("Le navigateur a bloqué l'ouverture de la fenêtre d'impression. Autorisez les pop-ups pour ce site.");
    return;
  }

  const config = this.systeme || {};
  const user = this.$store.getters.user || {};

  const patient = hospitalisation.patient || {};
  const chambre = hospitalisation.chambre || {};
  const lit = hospitalisation.lit || {};
  const typeChambre = chambre.type || {};

  /**
   * ============================================================
   * RECUPERATION DES PAIEMENTS
   * ============================================================
   */
  let paiements = [];

  try {

    const res = await api.getItems(
      "paiement_hospitalisations",
      {
        hospitalisation: hospitalisation.id
      }
    );

    paiements = res.data?.data || [];

  } catch (error) {

    console.error(
      "Erreur récupération paiements",
      error
    );

  }

  // Fallback
  if (
    !paiements.length &&
    Array.isArray(hospitalisation.paiements)
  ) {
    paiements = hospitalisation.paiements;
  }

  /**
   * ============================================================
   * DATES
   * ============================================================
   */
  const dateEntree =
    this.formatDate(hospitalisation.dateEntree);

  const dateSortiePrevue =
    this.formatDate(hospitalisation.dateSortiePrevue);

  const dateSortieReelle =
    hospitalisation.dateSortieReelle
      ? this.formatDate(hospitalisation.dateSortieReelle)
      : "EN COURS";

  /**
   * ============================================================
   * TARIFICATION
   * ============================================================
   */
  const tarifParJour = Number(
    typeChambre.tarifParJour || 0
  );

  const nombreJours = Number(
    hospitalisation.montantCalcule?.jours ||
    hospitalisation.montantReelCalcule?.jours ||
    0
  );

  const montantCalcule = Number(
    hospitalisation.montantCalcule?.montant ||
    hospitalisation.montantReelCalcule?.montant ||
    hospitalisation.montantFacture ||
    0
  );

  const totalPaye = Number(
    hospitalisation.totalPaye || 0
  );

  const resteAPayer = Number(
    hospitalisation.resteAPayer || 0
  );

  const remboursement = Number(
    hospitalisation.remboursement || 0
  );

  /**
   * ============================================================
   * PARTS ASSURANCE / PATIENT
   * ============================================================
   */
  let totalPatient = 0;
  let totalAssurance = 0;

  paiements.forEach(p => {

    totalPatient += Number(
      p.partPatient || 0
    );

    totalAssurance += Number(
      p.partAssurance || 0
    );

  });

  /**
   * ============================================================
   * ASSURANCES UTILISEES
   * ============================================================
   */
  const paiementsAvecContrat = paiements.filter(
    p => p.contratAssurance
  );

  /**
   * ============================================================
   * SERVEUR / LOGO
   * ============================================================
   */
  const baseURL =
    process.env.VUE_APP_API_BASE_URL ||
    "http://127.0.0.1:8000";

  const logoUrl = config.logo
    ? (
        config.logo.startsWith("http")
          ? config.logo
          : `${baseURL}${config.logo}`
      )
    : "";

  /**
   * ============================================================
   * HTML
   * ============================================================
   */
  const html = `
<!DOCTYPE html>
<html>

<head>

<title>HOSPITALISATION</title>

<style>

@page {
  size: 80mm auto;
  margin: 0;
}

body {
  width: 80mm;
  font-family: monospace;
  font-size: 12px;
  padding: 6px;
  color: #000;
  box-sizing: border-box;
}

.center {
  text-align: center;
}

.bold {
  font-weight: 900;
  font-size: 13px;
}

.big-bold {
  font-weight: 900;
  font-size: 14px;
  text-transform: uppercase;
}

.small {
  font-size: 11px;
}

.line {
  border-top: 2px dashed #000;
  margin: 6px 0;
}

.row {
  display: flex;
  justify-content: space-between;
  margin: 2px 0;
  font-size: 12px;
  gap: 8px;
}

.row span:first-child {
  text-align: left;
}

.row span:last-child {
  text-align: right;
}

.logo {
  width: 55px;
  height: 55px;
  object-fit: contain;
  display: block;
  margin: auto;
}

.section-title {
  text-align: center;
  font-weight: 900;
  font-size: 13px;
  margin: 6px 0;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  padding: 3px 0;
}

.assurance-box {
  margin-top: 4px;
  padding: 3px 0;
}

.total {
  font-size: 14px;
  font-weight: 900;
}

</style>

</head>

<body>


<!-- ========================================================= -->
<!-- EN-TETE -->
<!-- ========================================================= -->

<div class="center">

  ${
    logoUrl
      ? `<img src="${logoUrl}" class="logo">`
      : ""
  }

  <div class="bold">
    ${config.nom || "CLINIQUE MÉDICALE"}
  </div>

  <div class="small">
    ${config.telephone || ""}
  </div>

  <div class="small">
    ${config.adresse || ""}
  </div>

  ${
    config.email
      ? `<div class="small">${config.email}</div>`
      : ""
  }

</div>


<div class="line"></div>


<div class="section-title">
  HOSPITALISATION
</div>


<div class="bold">
  N° : ${hospitalisation.id || "—"}
</div>

<div class="bold">
  REF : ${hospitalisation.numHospitalisation || "—"}
</div>


<div class="line"></div>


<!-- ========================================================= -->
<!-- PATIENT -->
<!-- ========================================================= -->

<div class="section-title">
  PATIENT
</div>


<div class="bold">
  ${patient.nom || ""}
  ${patient.prenom || ""}
</div>

<div>
  Dossier :
  <b>${patient.numeroDossier || "—"}</b>
</div>

<div>
  Tél :
  <b>${patient.telephone || "—"}</b>
</div>


<div class="line"></div>


<!-- ========================================================= -->
<!-- INFORMATIONS -->
<!-- ========================================================= -->

<div class="section-title">
  INFORMATIONS
</div>


<div class="row">
  <span><b>Entrée</b></span>
  <span><b>${dateEntree}</b></span>
</div>

<div class="row">
  <span><b>Sortie prévue</b></span>
  <span><b>${dateSortiePrevue}</b></span>
</div>

<div class="row">
  <span><b>Sortie réelle</b></span>
  <span><b>${dateSortieReelle}</b></span>
</div>

<div class="row">
  <span><b>Statut</b></span>
  <span><b>${hospitalisation.statut || "—"}</b></span>
</div>

${
  hospitalisation.typeHospitalisation
    ? `
    <div class="row">
      <span><b>Type</b></span>
      <span>
        <b>
          ${hospitalisation.typeHospitalisation.libelle || "—"}
        </b>
      </span>
    </div>
    `
    : ""
}


<div class="line"></div>


<!-- ========================================================= -->
<!-- CHAMBRE / LIT -->
<!-- ========================================================= -->

<div class="section-title">
  CHAMBRE & LIT
</div>


<div class="row">
  <span><b>Chambre</b></span>
  <span><b>${chambre.numero || "—"}</b></span>
</div>

<div class="row">
  <span><b>Type</b></span>
  <span><b>${typeChambre.nom || "—"}</b></span>
</div>

<div class="row">
  <span><b>Tarif / jour</b></span>
  <span>
    <b>
      ${tarifParJour.toLocaleString()} F
    </b>
  </span>
</div>

<div class="row">
  <span><b>Nombre de jours</b></span>
  <span>
    <b>
      ${nombreJours}
      jour${nombreJours > 1 ? "s" : ""}
    </b>
  </span>
</div>

<div class="row">
  <span><b>Lit</b></span>
  <span><b>${lit.numero || "—"}</b></span>
</div>


<div class="line"></div>


<!-- ========================================================= -->
<!-- FACTURATION -->
<!-- ========================================================= -->

<div class="section-title">
  FACTURATION
</div>


<div class="row">
  <span><b>Tarif / jour</b></span>
  <span>
    <b>
      ${tarifParJour.toLocaleString()} F
    </b>
  </span>
</div>


<div class="row">
  <span><b>Jours</b></span>
  <span>
    <b>
      ${nombreJours}
    </b>
  </span>
</div>


<div class="row">
  <span><b>MONTANT</b></span>
  <span>
    <b>
      ${montantCalcule.toLocaleString()} F
    </b>
  </span>
</div>


<div class="line"></div>


<!-- ========================================================= -->
<!-- ASSURANCE -->
<!-- ========================================================= -->

<div class="section-title">
  ASSURANCE
</div>


${
  paiementsAvecContrat.length

    ? paiementsAvecContrat.map(p => {

        const contrat =
          p.contratAssurance || {};

        const assurance =
          contrat.assurance || {};

        const taux =
          contrat.tauxCouverture != null
            ? Number(
                contrat.tauxCouverture
              )
            : 0;

        const partAssurance =
          Number(
            p.partAssurance || 0
          );

        const partPatient =
          Number(
            p.partPatient || 0
          );

        return `

          <div class="assurance-box">

            <div class="row">
              <span><b>Assurance</b></span>
              <span>
                <b>
                  ${assurance.nom || "—"}
                </b>
              </span>
            </div>

            <div class="row">
              <span><b>N° assuré</b></span>
              <span>
                <b>
                  ${contrat.numeroAssure || "—"}
                </b>
              </span>
            </div>

            <div class="row">
              <span><b>Taux</b></span>
              <span>
                <b>
                  ${taux} %
                </b>
              </span>
            </div>

            <div class="row">
              <span><b>Part assurance</b></span>
              <span>
                <b>
                  ${partAssurance.toLocaleString()} F
                </b>
              </span>
            </div>

            <div class="row">
              <span><b>Part patient</b></span>
              <span>
                <b>
                  ${partPatient.toLocaleString()} F
                </b>
              </span>
            </div>

          </div>

        `;

      }).join("")

    : `

      <div class="center">
        <b>AUCUNE ASSURANCE</b>
      </div>

      `
}


<div class="line"></div>


<!-- ========================================================= -->
<!-- PAIEMENTS -->
<!-- ========================================================= -->

<div class="section-title">
  PAIEMENTS
</div>


<div class="row">
  <span><b>PART PATIENT</b></span>
  <span>
    <b>
      ${totalPatient.toLocaleString()} F
    </b>
  </span>
</div>


<div class="row">
  <span><b>PART ASSURANCE</b></span>
  <span>
    <b>
      ${totalAssurance.toLocaleString()} F
    </b>
  </span>
</div>


<div class="line"></div>


<div class="row total">
  <span>TOTAL PAYÉ</span>
  <span>
    ${totalPaye.toLocaleString()} F
  </span>
</div>


<div class="row">
  <span><b>RESTE</b></span>
  <span>
    <b>
      ${resteAPayer.toLocaleString()} F
    </b>
  </span>
</div>


${
  remboursement > 0

    ? `

      <div class="row">
        <span><b>REMBOURSEMENT</b></span>
        <span>
          <b>
            ${remboursement.toLocaleString()} F
          </b>
        </span>
      </div>

      `

    : ""
}


<div class="line"></div>


<!-- ========================================================= -->
<!-- AGENT -->
<!-- ========================================================= -->

<div class="center">

  <div class="bold">
    Agent
  </div>

  <div>
    ${user.nom || ""}
    ${user.prenom || ""}
  </div>

  <br>

  <div class="big-bold">
    MERCI POUR VOTRE CONFIANCE
  </div>

</div>


</body>

</html>
`;

  /**
   * ============================================================
   * IMPRESSION
   * ============================================================
   */

  printWindow.document.open();

  printWindow.document.write(html);

  printWindow.document.close();

  printWindow.onload = () => {

    printWindow.focus();

    printWindow.print();

    printWindow.close();

  };
},

async imprimerHospitalisationTicket58(hospitalisation) {
  if (!hospitalisation) return;

  const config = this.systeme || {};
  const user = this.$store.getters.user || {};

  const patient = hospitalisation.patient || {};
  const chambre = hospitalisation.chambre || {};
  const lit = hospitalisation.lit || {};
  const typeChambre = chambre.type || {};

  /**
   * ================================
   * DATES
   * ================================
   */
  const dateEntree = this.formatDate(
    hospitalisation.dateEntree
  );

  const dateSortiePrevue = hospitalisation.dateSortiePrevue
    ? this.formatDate(hospitalisation.dateSortiePrevue)
    : "—";

  const dateSortieReelle = hospitalisation.dateSortieReelle
    ? this.formatDate(hospitalisation.dateSortieReelle)
    : "EN COURS";

  /**
   * ================================
   * INFORMATIONS CHAMBRE
   * ================================
   */
  const tarifParJour = Number(
    typeChambre.tarifParJour || 0
  );

  const typeChambreNom =
    typeChambre.nom || "—";

  /**
   * ================================
   * INFORMATIONS FINANCIÈRES
   * ================================
   */
  const montantCalcule = Number(
    hospitalisation.montantCalcule?.montant ||
    hospitalisation.montantReelCalcule?.montant ||
    hospitalisation.montantFacture ||
    0
  );

  const jours = Number(
    hospitalisation.montantCalcule?.jours ||
    hospitalisation.montantReelCalcule?.jours ||
    0
  );

  const totalPaye = Number(
    hospitalisation.totalPaye || 0
  );

  const resteAPayer = Number(
    hospitalisation.resteAPayer || 0
  );

  const remboursement = Number(
    hospitalisation.remboursement || 0
  );

  const totalPartPatient = Number(
    hospitalisation.totalPartPatient ||
    hospitalisation.totalPatient ||
    0
  );

  const totalPartAssurance = Number(
    hospitalisation.totalPartAssurance ||
    hospitalisation.totalAssurance ||
    0
  );

  /**
   * ================================
   * RÉFÉRENCE
   * ================================
   */
  const reference =
    hospitalisation.numHospitalisation ||
    `HOS-${hospitalisation.id}-${new Date().getFullYear()}`;

  /**
   * ================================
   * LOGO
   * ================================
   */
  const baseURL =
    process.env.VUE_APP_API_BASE_URL ||
    "http://127.0.0.1:8000";

  const logoUrl = config.logo
    ? (
        config.logo.startsWith("http")
          ? config.logo
          : `${baseURL}${config.logo}`
      )
    : "";

  /**
   * ================================
   * FENÊTRE D'IMPRESSION
   * ================================
   */
  const printWindow = window.open("", "_blank");

  if (!printWindow) {
    console.error("Impossible d'ouvrir la fenêtre d'impression.");
    return;
  }

  /**
   * ================================
   * HTML
   * ================================
   */
  const html = `
<!DOCTYPE html>
<html>
<head>

<meta charset="UTF-8">

<title>Hospitalisation ${reference}</title>

<style>

@page {
  size: 58mm auto;
  margin: 0;
}

* {
  box-sizing: border-box;
}

body {
  width: 48mm;
  margin: 0 auto;
  padding: 3px;
  font-family: monospace;
  font-size: 9px;
  color: #000;
}

.center {
  text-align: center;
}

.bold {
  font-weight: 900;
  font-size: 10px;
}

.big-bold {
  font-weight: 900;
  font-size: 11px;
  text-transform: uppercase;
}

.small {
  font-size: 8px;
}

.line {
  border-top: 2px dashed #000;
  margin: 4px 0;
}

.row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 4px;
  margin: 2px 0;
  font-size: 9px;
}

.row span:first-child {
  text-align: left;
  flex: 1;
}

.row span:last-child {
  text-align: right;
  font-weight: bold;
}

.logo {
  width: 45px;
  height: 45px;
  object-fit: contain;
  display: block;
  margin: 0 auto 3px auto;
}

.section-title {
  text-align: center;
  font-weight: 900;
  font-size: 10px;
  margin: 4px 0;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  padding: 2px 0;
}

.total {
  font-size: 11px;
  font-weight: 900;
}

.footer {
  text-align: center;
  margin-top: 6px;
  font-size: 8px;
}

</style>

</head>

<body>

<!-- ========================= -->
<!-- EN-TÊTE -->
<!-- ========================= -->

<div class="center">

  ${
    logoUrl
      ? `<img src="${logoUrl}" class="logo">`
      : ""
  }

  <div class="bold">
    ${config.nom || "CLINIQUE MÉDICALE"}
  </div>

  ${
    config.telephone
      ? `<div class="small">Tél : ${config.telephone}</div>`
      : ""
  }

  ${
    config.adresse
      ? `<div class="small">${config.adresse}</div>`
      : ""
  }

  ${
    config.email
      ? `<div class="small">${config.email}</div>`
      : ""
  }

</div>

<div class="line"></div>

<!-- ========================= -->
<!-- HOSPITALISATION -->
<!-- ========================= -->

<div class="section-title">
  HOSPITALISATION
</div>

<div class="bold">
  REF : ${reference}
</div>

<div>
  ID : ${hospitalisation.id || "—"}
</div>

<div class="small">
  Entrée : ${dateEntree}
</div>

<div class="line"></div>

<!-- ========================= -->
<!-- PATIENT -->
<!-- ========================= -->

<div class="section-title">
  PATIENT
</div>

<div class="bold">
  ${patient.nom || ""} ${patient.prenom || ""}
</div>

<div>
  Dossier :
  <b>${patient.numeroDossier || "—"}</b>
</div>

<div>
  Tél :
  <b>${patient.telephone || "—"}</b>
</div>

${
  patient.genre
    ? `
<div>
  Genre :
  <b>${patient.genre}</b>
</div>
`
    : ""
}

<div class="line"></div>

<!-- ========================= -->
<!-- INFORMATIONS -->
<!-- ========================= -->

<div class="section-title">
  INFOS
</div>

<div class="row">
  <span>Entrée</span>
  <span>${dateEntree}</span>
</div>

<div class="row">
  <span>Sortie prévue</span>
  <span>${dateSortiePrevue}</span>
</div>

<div class="row">
  <span>Sortie réelle</span>
  <span>${dateSortieReelle}</span>
</div>

<div class="row">
  <span>Statut</span>
  <span>${hospitalisation.statut || "—"}</span>
</div>

<div class="line"></div>

<!-- ========================= -->
<!-- CHAMBRE / LIT -->
<!-- ========================= -->

<div class="section-title">
  CHAMBRE / LIT
</div>

<div class="row">
  <span>Chambre</span>
  <span>${chambre.numero || "—"}</span>
</div>

<div class="row">
  <span>Type</span>
  <span>${typeChambreNom}</span>
</div>

<div class="row">
  <span>Tarif / jour</span>
  <span>${tarifParJour.toLocaleString()} F</span>
</div>

${
  jours > 0
    ? `
<div class="row">
  <span>Nombre de jours</span>
  <span>${jours}</span>
</div>
`
    : ""
}

<div class="row">
  <span>Lit</span>
  <span>${lit.numero || "—"}</span>
</div>

<div class="line"></div>

<!-- ========================= -->
<!-- SITUATION FINANCIÈRE -->
<!-- ========================= -->

<div class="section-title">
  FINANCES
</div>

<div class="row">
  <span>Tarif / jour</span>
  <span>${tarifParJour.toLocaleString()} F</span>
</div>

${
  jours > 0
    ? `
<div class="row">
  <span>Jours</span>
  <span>${jours}</span>
</div>
`
    : ""
}

<div class="row">
  <span>Montant</span>
  <span>${montantCalcule.toLocaleString()} F</span>
</div>

<div class="row">
  <span>Part patient</span>
  <span>${totalPartPatient.toLocaleString()} F</span>
</div>

<div class="row">
  <span>Part assurance</span>
  <span>${totalPartAssurance.toLocaleString()} F</span>
</div>

<div class="line"></div>

<div class="row total">
  <span>PAYÉ</span>
  <span>${totalPaye.toLocaleString()} F</span>
</div>

<div class="row total">
  <span>RESTE</span>
  <span>${resteAPayer.toLocaleString()} F</span>
</div>

${
  remboursement > 0
    ? `
<div class="row">
  <span>Remboursement</span>
  <span>${remboursement.toLocaleString()} F</span>
</div>
`
    : ""
}

<div class="line"></div>

<!-- ========================= -->
<!-- AGENT -->
<!-- ========================= -->

<div class="center">

  <div class="bold">
    Agent
  </div>

  <div>
    ${user.nom || ""} ${user.prenom || ""}
  </div>

  <br>

  <div class="big-bold">
    MERCI
  </div>

</div>

<div class="footer">

  ${
    config.nom
      ? `<div>${config.nom}</div>`
      : ""
  }

  <div>
    Document généré le ${this.formatDateTime(new Date())}
  </div>

</div>

</body>
</html>
`;

  /**
   * ================================
   * IMPRESSION
   * ================================
   */

  printWindow.document.open();
  printWindow.document.write(html);
  printWindow.document.close();

  printWindow.onload = () => {
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
},

async imprimerPaiementHospitalisationA4(paiement, hospitalisation) {

  if (!paiement || !hospitalisation) return;

  const config = this.systeme || {};
  const user = this.$store.getters.user || {};

  const patient = hospitalisation.patient || {};

  // ============================================================
  // DATE DU PAIEMENT
  // ============================================================

  const datePaiement = this.formatDateTime(
    paiement.datePaiement || paiement.createdAt
  );

  // ============================================================
  // REFERENCE
  // ============================================================

  const reference =
    paiement.ref ||
    hospitalisation.numHospitalisation ||
    `PAY-HOSP-${hospitalisation.id}-${new Date().getFullYear()}`;

  // ============================================================
  // CONTRAT ASSURANCE
  // ============================================================

  const contratAssurance = paiement.contratAssurance || null;

  // Nom assurance
  const assuranceNom =
    contratAssurance?.assurance?.nom || null;

  // Numéro assuré
  const numeroAssure =
    contratAssurance?.numeroAssure || "—";

  // Taux couverture
  const tauxCouverture =
    contratAssurance?.tauxCouverture != null
      ? Number(contratAssurance.tauxCouverture)
      : 0;

  // ============================================================
  // MONTANTS
  // ============================================================

  const montantBase = Number(
    paiement.montantBase ?? paiement.montant ?? 0
  );

  const montantPaye = Number(
    paiement.montant ?? 0
  );

  const partPatient = Number(
    paiement.partPatient ?? 0
  );

  const partAssurance = Number(
    paiement.partAssurance ?? 0
  );

  // ============================================================
  // SERVEUR / LOGO
  // ============================================================

  const baseURL =
    process.env.VUE_APP_API_BASE_URL ||
    "http://127.0.0.1:8000";

  const logoUrl = config.logo
    ? (
        config.logo.startsWith("http")
          ? config.logo
          : `${baseURL}${config.logo}`
      )
    : "";

  // ============================================================
  // FENETRE D'IMPRESSION
  // ============================================================

  const printWindow = window.open("", "_blank");

  if (!printWindow) {
    alert("Impossible d'ouvrir la fenêtre d'impression.");
    return;
  }

  // ============================================================
  // HTML
  // ============================================================

  const html = `
<!DOCTYPE html>

<html lang="fr">

<head>

<meta charset="UTF-8">

<title>Reçu paiement hospitalisation</title>

<style>

@page {
  size: A4;
  margin: 2cm;
}

body {
  font-family: "Times New Roman", serif;
  font-size: 14px;
  color: #000;
  margin: 0;
}

header {
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #198754;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

header img {
  width: 80px;
  height: 80px;
  object-fit: contain;
}

.clinic-info h2 {
  margin: 0;
  color: #198754;
}

.clinic-info p {
  margin: 2px 0;
  font-size: 13px;
}

h3 {
  text-align: center;
  color: #198754;
  text-decoration: underline;
  margin: 20px 0;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
}

th,
td {
  border: 1px solid #198754;
  padding: 10px;
  font-size: 13px;
}

th {
  background: #e9f7ef;
}

.text-right {
  text-align: right;
}

.assurance {
  background: #f1f8ff;
}

.total {
  font-size: 15px;
  font-weight: bold;
}

.signature {
  margin-top: 50px;
  text-align: right;
}

footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid #198754;
  padding-top: 5px;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
}

</style>

</head>

<body>

<!-- ========================================================= -->
<!-- ENTETE -->
<!-- ========================================================= -->

<header>

  <div style="display:flex;gap:10px;">

    ${
      logoUrl
        ? `<img src="${logoUrl}" />`
        : ""
    }

    <div class="clinic-info">

      <h2>
        ${config.nom || "CLINIQUE MÉDICALE"}
      </h2>

      <p>
        ${config.adresse || ""}
      </p>

      <p>
        Tél : ${config.telephone || ""}
      </p>

      ${
        config.email
          ? `<p>Email : ${config.email}</p>`
          : ""
      }

    </div>

  </div>

  <div style="text-align:right">

    <p>
      <strong>Reçu N° :</strong>
      ${reference}
    </p>

    <p>
      <strong>Date :</strong>
      ${datePaiement}
    </p>

  </div>

</header>


<!-- ========================================================= -->
<!-- TITRE -->
<!-- ========================================================= -->

<h3>
  REÇU DE PAIEMENT - HOSPITALISATION
</h3>


<!-- ========================================================= -->
<!-- INFORMATIONS PATIENT -->
<!-- ========================================================= -->

<table>

  <tr>

    <td>
      <strong>Patient :</strong>
      ${patient.nom || ""}
      ${patient.prenom || ""}
    </td>

    <td>
      <strong>Dossier :</strong>
      ${patient.numeroDossier || "—"}
    </td>

  </tr>


  <tr>

    <td>
      <strong>N° Hospitalisation :</strong>
      ${hospitalisation.numHospitalisation || "—"}
    </td>

    <td>
      <strong>Mode paiement :</strong>
      ${paiement.modePaiement?.nom || "—"}
    </td>

  </tr>


  <tr>

    <td>
      <strong>Date paiement :</strong>
      ${datePaiement}
    </td>

    <td>
      <strong>Statut :</strong>
      Payé
    </td>

  </tr>

</table>


<!-- ========================================================= -->
<!-- PAIEMENT -->
<!-- ========================================================= -->

<table>

  <thead>

    <tr>

      <th>Montant base</th>

      <th>Montant payé</th>

      <th>Assurance</th>

      <th>Taux couverture</th>

      <th>Part Assurance</th>

      <th>Part Patient</th>

    </tr>

  </thead>


  <tbody>

    <tr>

      <td class="text-right">
        ${montantBase.toLocaleString("fr-FR")} FCFA
      </td>


      <td class="text-right">
        <strong>
          ${montantPaye.toLocaleString("fr-FR")} FCFA
        </strong>
      </td>


      <td class="assurance">

        ${
          assuranceNom
            ? `
              <strong>${assuranceNom}</strong>
              <br>
              N° ${numeroAssure}
            `
            : "Aucune assurance"
        }

      </td>


      <td class="text-right">

        ${
          contratAssurance
            ? `${tauxCouverture}%`
            : "—"
        }

      </td>


      <td class="text-right">

        ${partAssurance.toLocaleString("fr-FR")} FCFA

      </td>


      <td class="text-right">

        ${partPatient.toLocaleString("fr-FR")} FCFA

      </td>

    </tr>

  </tbody>

</table>


<!-- ========================================================= -->
<!-- DETAILS ASSURANCE -->
<!-- ========================================================= -->

${
  contratAssurance
    ? `

<table>

  <tr>

    <td>
      <strong>Contrat Assurance Patient</strong>
    </td>

    <td>
      ${assuranceNom || "—"}
    </td>

  </tr>


  <tr>

    <td>
      Numéro assuré
    </td>

    <td>
      ${numeroAssure}
    </td>

  </tr>


  <tr>

    <td>
      Taux couverture
    </td>

    <td>
      <strong>
        ${tauxCouverture} %
      </strong>
    </td>

  </tr>

</table>

`
    : `

<p style="margin-top:20px">

  <strong>
    Paiement effectué intégralement par le patient.
  </strong>

</p>

`
}


<!-- ========================================================= -->
<!-- SIGNATURE -->
<!-- ========================================================= -->

<div class="signature">

  <p>
    <strong>L'Agent</strong>
  </p>

  <p>
    ${user.nom || ""}
    ${user.prenom || ""}
  </p>

  <br>
  <br>

  <p>
    Signature & cachet
  </p>

</div>


<!-- ========================================================= -->
<!-- FOOTER -->
<!-- ========================================================= -->

<footer>

  <span>
    ${config.nom || ""}
    -
    ${config.adresse || ""}
  </span>

  <span>
    © ${new Date().getFullYear()}
  </span>

</footer>


</body>

</html>
`;

  // ============================================================
  // IMPRESSION
  // ============================================================

  printWindow.document.open();
  printWindow.document.write(html);
  printWindow.document.close();

  printWindow.onload = () => {

    printWindow.focus();

    printWindow.print();

    printWindow.close();

  };
},

async imprimerPaiementHospitalisationTicketEpson(
  paiement,
  hospitalisation
) {
  if (!paiement || !hospitalisation) return;

  // ============================================================
  // CONFIGURATION
  // ============================================================

  const config = this.systeme || {};
  const user = this.$store.getters.user || {};
  const patient = hospitalisation.patient || {};

  // ============================================================
  // DATE
  // ============================================================

  const datePaiement = this.formatDateTime(
    paiement.datePaiement || paiement.createdAt
  );

  // ============================================================
  // REFERENCE
  // ============================================================

  const reference =
    paiement.ref ||
    hospitalisation.numHospitalisation ||
    `PAY-HOSP-${hospitalisation.id}-${new Date().getFullYear()}`;

  // ============================================================
  // CONTRAT ASSURANCE
  // ============================================================

  const contratAssurance =
    paiement.contratAssurance || null;

  // Nom de l'assurance
  const assuranceNom =
    contratAssurance?.assurance?.nom || null;

  // Numéro assuré
  const numeroAssure =
    contratAssurance?.numeroAssure || "—";

  // Taux de couverture
  const tauxCouverture =
    contratAssurance?.tauxCouverture != null
      ? Number(contratAssurance.tauxCouverture)
      : 0;

  // ============================================================
  // MONTANTS
  // ============================================================

  const montantBase = Number(
    paiement.montantBase ?? paiement.montant ?? 0
  );

  const montantPaye = Number(
    paiement.montant ?? 0
  );

  const partPatient = Number(
    paiement.partPatient ?? 0
  );

  const partAssurance = Number(
    paiement.partAssurance ?? 0
  );

  // ============================================================
  // SERVEUR / LOGO
  // ============================================================

  const baseURL =
    process.env.VUE_APP_API_BASE_URL ||
    "http://127.0.0.1:8000";

  const logoUrl = config.logo
    ? (
        config.logo.startsWith("http")
          ? config.logo
          : `${baseURL}${config.logo}`
      )
    : "";

  // ============================================================
  // FENETRE IMPRESSION
  // ============================================================

  const printWindow = window.open("", "_blank");

  if (!printWindow) {
    alert("Impossible d'ouvrir la fenêtre d'impression.");
    return;
  }

  // ============================================================
  // HTML TICKET 80 MM
  // ============================================================

  const html = `
<!DOCTYPE html>

<html lang="fr">

<head>

<meta charset="UTF-8">

<title>REÇU PAIEMENT HOSPITALISATION</title>

<style>

@page {
  size: 80mm auto;
  margin: 0;
}

* {
  box-sizing: border-box;
}

body {
  width: 80mm;
  margin: 0;
  padding: 6px;
  font-family: monospace;
  font-size: 12px;
  color: #000;
}

.center {
  text-align: center;
}

.bold {
  font-weight: 900;
  font-size: 13px;
}

.big-bold {
  font-weight: 900;
  font-size: 14px;
}

.small {
  font-size: 10px;
}

.line {
  border-top: 2px dashed #000;
  margin: 6px 0;
}

.row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 5px;
  margin: 3px 0;
  font-size: 12px;
}

.row span:first-child {
  text-align: left;
}

.row span:last-child {
  text-align: right;
}

.logo {
  width: 50px;
  height: 50px;
  object-fit: contain;
  display: block;
  margin: 0 auto 4px auto;
}

.section-title {
  text-align: center;
  font-weight: 900;
  font-size: 13px;
  margin: 6px 0;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  padding: 3px 0;
}

.assurance-box {
  border: 1px solid #000;
  padding: 5px;
  margin-top: 5px;
}

.footer {
  margin-top: 8px;
  text-align: center;
}

</style>

</head>

<body>


<!-- ========================================================= -->
<!-- ENTETE -->
<!-- ========================================================= -->

<div class="center">

  ${
    logoUrl
      ? `<img src="${logoUrl}" class="logo">`
      : ""
  }

  <div class="bold">
    ${config.nom || "CLINIQUE MÉDICALE"}
  </div>

  ${
    config.telephone
      ? `<div class="small">Tél : ${config.telephone}</div>`
      : ""
  }

  ${
    config.adresse
      ? `<div class="small">${config.adresse}</div>`
      : ""
  }

  ${
    config.email
      ? `<div class="small">${config.email}</div>`
      : ""
  }

</div>


<div class="line"></div>


<!-- ========================================================= -->
<!-- TITRE -->
<!-- ========================================================= -->

<div class="section-title">
  REÇU DE PAIEMENT
</div>


<div class="bold">
  N° : ${reference}
</div>

<div class="bold">
  DATE : ${datePaiement}
</div>


<div class="line"></div>


<!-- ========================================================= -->
<!-- PATIENT -->
<!-- ========================================================= -->

<div class="section-title">
  PATIENT
</div>

<div class="bold">
  ${patient.nom || ""}
  ${patient.prenom || ""}
</div>

<div>
  Dossier :
  <b>${patient.numeroDossier || "—"}</b>
</div>

<div>
  HOSP :
  <b>${hospitalisation.numHospitalisation || "—"}</b>
</div>


<div class="line"></div>


<!-- ========================================================= -->
<!-- PAIEMENT -->
<!-- ========================================================= -->

<div class="section-title">
  PAIEMENT
</div>


<div class="row">

  <span>
    <b>Mode</b>
  </span>

  <span>
    <b>${paiement.modePaiement?.nom || "—"}</b>
  </span>

</div>


<div class="row">

  <span>
    <b>Type</b>
  </span>

  <span>
    <b>${paiement.type || "—"}</b>
  </span>

</div>


<div class="line"></div>


<!-- ========================================================= -->
<!-- MONTANTS -->
<!-- ========================================================= -->

<div class="row">

  <span>
    <b>Montant base</b>
  </span>

  <span>
    <b>
      ${montantBase.toLocaleString("fr-FR")} F
    </b>
  </span>

</div>


<div class="row">

  <span>
    <b>Part assurance</b>
  </span>

  <span>
    <b>
      ${partAssurance.toLocaleString("fr-FR")} F
    </b>
  </span>

</div>


<div class="row">

  <span>
    <b>Part patient</b>
  </span>

  <span>
    <b>
      ${partPatient.toLocaleString("fr-FR")} F
    </b>
  </span>

</div>


<!-- ========================================================= -->
<!-- ASSURANCE -->
<!-- ========================================================= -->

${
  contratAssurance
    ? `

<div class="line"></div>

<div class="section-title">
  ASSURANCE
</div>

<div class="assurance-box">

  <div class="row">

    <span>
      <b>Assurance</b>
    </span>

    <span>
      <b>
        ${assuranceNom || "—"}
      </b>
    </span>

  </div>


  <div class="row">

    <span>
      <b>N° assuré</b>
    </span>

    <span>
      <b>
        ${numeroAssure}
      </b>
    </span>

  </div>


  <div class="row">

    <span>
      <b>Couverture</b>
    </span>

    <span>
      <b>
        ${tauxCouverture} %
      </b>
    </span>

  </div>

</div>

`
    : `

<div class="line"></div>

<div class="center">

  <b>AUCUNE ASSURANCE</b>

</div>

`
}


<div class="line"></div>


<!-- ========================================================= -->
<!-- TOTAL -->
<!-- ========================================================= -->

<div class="row big-bold">

  <span>
    TOTAL PAYÉ
  </span>

  <span>
    ${montantPaye.toLocaleString("fr-FR")} FCFA
  </span>

</div>


<div class="line"></div>


<!-- ========================================================= -->
<!-- AGENT -->
<!-- ========================================================= -->

<div class="center">

  <div class="bold">
    Agent
  </div>

  <div>
    ${user.nom || ""}
    ${user.prenom || ""}
  </div>

  <br>

  <div class="big-bold">
    MERCI POUR VOTRE CONFIANCE
  </div>

</div>


</body>

</html>
`;

  // ============================================================
  // ECRITURE
  // ============================================================

  printWindow.document.open();

  printWindow.document.write(html);

  printWindow.document.close();

  // ============================================================
  // IMPRESSION
  // ============================================================

  printWindow.onload = () => {

    printWindow.focus();

    printWindow.print();

    printWindow.close();

  };
},

async imprimerPaiementHospitalisationTicket58(paiement, hospitalisation) {
  if (!paiement || !hospitalisation) return;

  const config = this.systeme || {};
  const user = this.$store.getters.user || {};
  const patient = hospitalisation.patient || {};

  const datePaiement = this.formatDateTime(
    paiement.datePaiement || paiement.createdAt
  );

  // ============================================================
  // RÉFÉRENCE DU PAIEMENT
  // ============================================================
  const reference =
    paiement.ref ||
    hospitalisation.numHospitalisation ||
    `PAY-HOSP-${hospitalisation.id}-${new Date().getFullYear()}`;

  // ============================================================
  // ASSURANCE
  // Les informations sont dans contratAssurance
  // ============================================================
  const contratAssurance = paiement.contratAssurance || null;

  const assuranceNom =
    contratAssurance?.assurance?.nom || null;

  const numeroAssure =
    contratAssurance?.numeroAssure || "—";

  const tauxCouverture =
    contratAssurance?.tauxCouverture != null
      ? Number(contratAssurance.tauxCouverture)
      : 0;

  // ============================================================
  // MONTANTS
  // ============================================================
  const montantBase = Number(
    paiement.montantBase || 0
  );

  const montantPaye = Number(
    paiement.montant || 0
  );

  const partPatient = Number(
    paiement.partPatient || 0
  );

  const partAssurance = Number(
    paiement.partAssurance || 0
  );

  // ============================================================
  // CONFIGURATION
  // ============================================================
  const baseURL =
    process.env.VUE_APP_API_BASE_URL ||
    "http://127.0.0.1:8000";

  const logoUrl = config.logo
    ? (
        config.logo.startsWith("http")
          ? config.logo
          : `${baseURL}${config.logo}`
      )
    : "";

  // ============================================================
  // FENÊTRE D'IMPRESSION
  // ============================================================
  const printWindow = window.open("", "_blank");

  if (!printWindow) {
    alert("Impossible d'ouvrir la fenêtre d'impression.");
    return;
  }

  // ============================================================
  // HTML
  // ============================================================
  const html = `
<!DOCTYPE html>
<html>
<head>

<meta charset="UTF-8">

<title>REÇU PAIEMENT HOSPITALISATION</title>

<style>

@page {
  size: 58mm auto;
  margin: 0;
}

* {
  box-sizing: border-box;
}

body {
  width: 48mm;
  font-family: monospace;
  font-size: 9px;
  padding: 3px;
  margin: 0 auto;
  color: #000;
}

.center {
  text-align: center;
}

.bold {
  font-weight: 900;
  font-size: 10px;
}

.big-bold {
  font-weight: 900;
  font-size: 11px;
}

.small {
  font-size: 8px;
}

.line {
  border-top: 2px dashed #000;
  margin: 4px 0;
}

.row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin: 2px 0;
  font-size: 9px;
  gap: 4px;
}

.row span:first-child {
  flex: 1;
}

.row span:last-child {
  text-align: right;
  font-weight: bold;
}

.logo {
  width: 40px;
  height: 40px;
  object-fit: contain;
  display: block;
  margin: auto;
}

.section-title {
  text-align: center;
  font-weight: 900;
  font-size: 10px;
  margin: 4px 0;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  padding: 2px 0;
}

.assurance-box {
  margin-top: 3px;
  padding: 3px 0;
}

.assurance-title {
  font-weight: bold;
  text-align: center;
  margin-bottom: 3px;
}

.footer {
  text-align: center;
  margin-top: 5px;
}

</style>

</head>

<body>

<!-- ========================================================= -->
<!-- EN-TÊTE -->
<!-- ========================================================= -->

<div class="center">

  ${
    logoUrl
      ? `<img src="${logoUrl}" class="logo">`
      : ""
  }

  <div class="bold">
    ${config.nom || "CLINIQUE MÉDICALE"}
  </div>

  ${
    config.telephone
      ? `<div class="small">Tél : ${config.telephone}</div>`
      : ""
  }

  ${
    config.adresse
      ? `<div class="small">${config.adresse}</div>`
      : ""
  }

  ${
    config.email
      ? `<div class="small">${config.email}</div>`
      : ""
  }

</div>


<div class="line"></div>


<!-- ========================================================= -->
<!-- TITRE -->
<!-- ========================================================= -->

<div class="section-title">
  REÇU PAIEMENT
</div>


<div class="bold">
  N° : ${reference}
</div>

<div class="bold">
  DATE : ${datePaiement}
</div>


<div class="line"></div>


<!-- ========================================================= -->
<!-- PATIENT -->
<!-- ========================================================= -->

<div class="section-title">
  PATIENT
</div>

<div class="bold">
  ${patient.nom || ""} ${patient.prenom || ""}
</div>

<div>
  Dossier :
  <b>${patient.numeroDossier || "—"}</b>
</div>

<div>
  HOSP :
  <b>${hospitalisation.numHospitalisation || "—"}</b>
</div>


<div class="line"></div>


<!-- ========================================================= -->
<!-- PAIEMENT -->
<!-- ========================================================= -->

<div class="section-title">
  PAIEMENT
</div>


<div class="row">
  <span>Mode</span>
  <span>
    ${paiement.modePaiement?.nom || "—"}
  </span>
</div>


<div class="row">
  <span>Type</span>
  <span>
    ${paiement.type || "—"}
  </span>
</div>


<div class="line"></div>


<!-- ========================================================= -->
<!-- MONTANTS -->
<!-- ========================================================= -->

<div class="row">
  <span>Base</span>
  <span>
    ${montantBase.toLocaleString()} F
  </span>
</div>


<div class="row">
  <span>Assurance</span>
  <span>
    ${partAssurance.toLocaleString()} F
  </span>
</div>


<div class="row">
  <span>Patient</span>
  <span>
    ${partPatient.toLocaleString()} F
  </span>
</div>


${
  contratAssurance
    ? `

<div class="line"></div>

<!-- ========================================================= -->
<!-- ASSURANCE -->
<!-- ========================================================= -->

<div class="section-title">
  ASSURANCE
</div>

<div class="assurance-box">

  <div class="row">
    <span>Assurance</span>
    <span>
      ${assuranceNom || "—"}
    </span>
  </div>

  <div class="row">
    <span>N° assuré</span>
    <span>
      ${numeroAssure}
    </span>
  </div>

  <div class="row">
    <span>Couverture</span>
    <span>
      ${tauxCouverture}%
    </span>
  </div>

</div>

`
    : `

<div class="line"></div>

<div class="center">
  <b>AUCUNE ASSURANCE</b>
</div>

`
}


<div class="line"></div>


<!-- ========================================================= -->
<!-- TOTAL -->
<!-- ========================================================= -->

<div class="row big-bold">

  <span>
    TOTAL PAYÉ
  </span>

  <span>
    ${montantPaye.toLocaleString()} F
  </span>

</div>


<div class="line"></div>


<!-- ========================================================= -->
<!-- AGENT -->
<!-- ========================================================= -->

<div class="center">

  <div class="bold">
    Agent
  </div>

  <div>
    ${user.nom || ""} ${user.prenom || ""}
  </div>

  <br>

  <div class="big-bold">
    MERCI
  </div>

  <div class="small">
    POUR VOTRE CONFIANCE
  </div>

</div>


</body>
</html>
`;

  // ============================================================
  // IMPRESSION
  // ============================================================

  printWindow.document.open();
  printWindow.document.write(html);
  printWindow.document.close();

  printWindow.onload = () => {
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
},

    printPage() { window.print(); }
  }
};
</script>

<style scoped>
.section-title { font-weight: bold; color: #0d6efd; }

.modal-backdrop-custom {
  position: fixed; top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0,0,0,0.4);
  display: flex; align-items: center; justify-content: center; padding: 10px;
}
.modal-custom { background: white; width: 100%; max-width: 400px; padding: 20px; border-radius: 8px; }
.table-responsive { overflow-x: auto; }
</style>